import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
    :root {
        --font-family: 'Manrope', sans-serif;

        --gradient-text: linear-gradient(89.97deg, #9B55C5 1.84%, #5079FF 102.67%);
        --gradient-bar: linear-gradient(103.22deg, #9B55C5 -13.86%, #5079FF 99.55%);
        
        --color-bg: #040C18;
        --color-footer : #040617;
        --color-blog: #042c54;
        --color-text: #C2C3DF;
        --color-subtext: #5079FF;
        --color-button: #8A0BC8;
    }

    html, body, div, span, applet, object, iframe,
    blockquote, pre,
    a, abbr, acronym, address, big, cite, code,
    del, dfn, em, img, ins, kbd, q, s, samp,
    small, strike, strong, sub, sup, tt, var,
    b, u, i, center,
    dl, dt, dd, ol, ul, li,
    fieldset, form, label, legend,
    table, caption, tbody, tfoot, thead, tr, th, td,
    article, aside, canvas, details, embed, 
    figure, figcaption, footer, header, hgroup, 
    menu, nav, output, ruby, section, summary,
    time, mark, audio, video {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        font: inherit;
        vertical-align: baseline;
    }
    * {
        box-sizing: border-box;
        scroll-behavior: smooth;
    }
    input {
        &:disabled {
            cursor: not-allowed;
        }
    }
    /* HTML5 display-role reset for older browsers */
    article, aside, details, figcaption, figure, 
    footer, header, hgroup, menu, nav, section {
        display: block;
    }
    body {
        background: var(--color-bg);
    }
    ol, ul {
        list-style: none;
    }
    blockquote, q {
        quotes: none;
    }
    blockquote:before, blockquote:after,
    q:before, q:after {
        content: '';
        content: none;
    }
    table {
        border-collapse: collapse;
        border-spacing: 0;
    }
    a {
        color: unset;
        text-decoration: none;
    }
`

export default GlobalStyle
